
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';
import { DnsCheckResult } from '@/services/DnsChecker';
import { CertificateInterface } from '@/services/SSL/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class WebsiteHealthResult extends Vue {
  @Prop({ type: Object, required: true })
  public website!: Website;

  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Object, default: null })
  public dns!: DnsCheckResult | null;

  @Prop({ type: String, default: '' })
  public dnsError!: string;

  @Prop({ type: Object, default: null })
  public ssl!: CertificateInterface | null;

  @Prop({ type: String, default: '' })
  public sslError!: string;

  @Prop({ type: String, default: '' })
  public creationStatus!: string;

  @Prop({ type: String, default: '' })
  public deletionStatus!: string;

  @Prop({ type: String, default: '' })
  public orchestratorError!: string;

  public get dnsSummary(): string {
    if (this.dnsError) {
      return 'error';
    }
    if (!this.dns) {
      return '—';
    }
    const a = (this.dns.a_records || [])[0];
    return a || this.dns.provider || 'ok';
  }

  public get sslSummary(): string {
    if (this.sslError) {
      return 'error';
    }
    if (!this.ssl) {
      return 'none';
    }
    return this.ssl.status || 'ok';
  }
}
